import { enumMessageTypes } from "./common-enums";

export class commonMessage {

    //Variable Declarations
    "cnum_messageId" : number; 
    public cnum_messageType : enumMessageTypes = enumMessageTypes.TypeNone;
    public cstr_messageText : string = "";

    //Properties Declarations
    public get getMessage() : string {
        return this.cstr_messageText;
    };

    public set setMessage(value : string) {
        this.cstr_messageText = value;
    };

    //Event Declarations
    constructor(){
    };

};